'use strict';

angular.module('formonlineApp')
		.controller('NavbarController', function ($scope, $state, $log, Auth, Principal, SidebarService) {
			$scope.isAuthenticated = Principal.isAuthenticated;
			$scope.$state = $state;

			$scope.logout = function () {
				Auth.logout();
				$state.go('home');
			};

			$scope.clearSideBarMenu = function () {
				//on vide le menu
				SidebarService.delAllMenus();
			};
		});
